import {AccessibilityIcon} from "./Icons";

const AccessibilityButton = ({
    href,
    target = "_self",
    variant = 'light',
    iconStroke = "#fff",
    textLabel = "Toegankelijkheid en privacy"
}) => {
    return (
        <a
            className={`button button--features ${variant}`}
            href={href}
            target={target}
            rel="noopener noreferrer"
            aria-label="Open PDF bestand: inspectie-wbp6hhdelflandnl-11-2024.pdf"
        >
            <AccessibilityIcon stroke={iconStroke} />
            <span className="button__label">{textLabel}</span>
        </a>
    )
}
export default AccessibilityButton;